import { render } from "./AuthenticationByKeys.vue?vue&type=template&id=aa504c80"
import script from "./AuthenticationByKeys.vue?vue&type=script&lang=js"
export * from "./AuthenticationByKeys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__